import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import * as _ from 'lodash';
import { MatDialog, MatSnackBar } from '@angular/material';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { Observable } from 'rxjs';
import { LearnerService } from '../../services/learner.service';
@Component({
  selector: 'app-portfolio-assessment-plan',
  templateUrl: './portfolio-assessment-plan.component.html',
  styleUrls: ['./portfolio-assessment-plan.component.scss']
})
export class PortfolioAssessmentPlanComponent implements OnInit {
  medicalSign

  @Input('learner') learnerObj;
  @Input('jobId') job;
  @Input('assessment') editAssesment
  currentJob
  learnerData
  assesmentForm
  qualificationTitle = 'Level 2 NVQ Diploma in Rail Engineering Track Maintenance';
  assesmentNo = 'QRTM2-001, 003, 004, 005, 006, 007, 008, 009, 011, 016, 017';
  learnerName
  assesmentEdit
  signature = false
  signature1 = false
  signature2 = false
  signature3 = false
  loading = false
  isEdit: boolean = false
  constructor(
    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,

    public _learnerService: LearnerService,
  ) { }

  ngOnInit() {
    if(!this.isEdit)
      this.createForm()
  }


  ngOnChanges(changes: SimpleChanges) {
    console.log("there are changes in assesment plan", changes)
    if (changes.job && changes.job.currentValue) {
      this.currentJob = changes.job.currentValue
    }

    if (changes.learnerObj && changes.learnerObj.currentValue) {
      this.learnerData = changes.learnerObj.currentValue
      this.learnerName = this.learnerData.name
      // this.createForm()
    }

    if (changes.editAssesment && changes.editAssesment.currentValue && changes.editAssesment.currentValue.assesmentForm) {
      this.assesmentEdit = changes.editAssesment.currentValue.assesmentForm
      let size = Object.keys(this.assesmentEdit).length;
      if (size != 0) {
        console.log("this is for edit");

        if (this.assesmentEdit && this.assesmentEdit.signature != "") {
          this.signature = true
        }
        if (this.assesmentEdit && this.assesmentEdit.signature1 != "") {
          this.signature1 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.signature2 != "") {
          this.signature2 = true
        }
        if (this.assesmentEdit && this.assesmentEdit.signature3 != "") {
          this.signature3 = true
        }
        this.isEdit = true
        this.createForm(this.assesmentEdit)

      } else {
        this.isEdit = false
        this.createForm()
      }
      // console.log('changes.editAssesment.currentValue', changes.editAssesment.currentValue)
    }
  }



  // FORM CONTROLL

  createForm(details?) {
    console.log("details while edit", details);

    this.assesmentForm = new FormGroup({
      qualificationTitle: new FormControl((details && details.qualificationTitle) ? details.qualificationTitle : this.qualificationTitle),
      assesmentNo: new FormControl((details && details.assesmentNo) ? details.assesmentNo : this.assesmentNo),
      assesmentCenter: new FormControl((details && details.assesmentCenter) ? details.assesmentCenter : ''),
      centerNumber: new FormControl((details && details.centerNumber) ? details.centerNumber : ''),
      assesmentLocation: new FormControl((details && details.assesmentLocation) ? details.assesmentLocation : ''),
      candidateName: new FormControl((details && details.candidateName) ? details.candidateName : this.learnerName),
      assesorList: this.formBuilder.array(this.assesorList((details && details.assesorList) ? details.assesorList : [])),
      verifierList: this.formBuilder.array(this.verifierList((details && details.verifierList) ? details.verifierList : [])),
      sampleList: this.formBuilder.array(this.sampleList((details && details.sampleList) ? details.sampleList : [])),
      agreementPlanDate: new FormControl((details && details.agreementPlanDate) ? details.agreementPlanDate : ''),
      agreementCompleteDate: new FormControl((details && details.agreementCompleteDate) ? details.agreementCompleteDate : ''),
      signature: new FormControl((details && details.signature) ? details.signature : ''),
      signature1: new FormControl((details && details.signature1) ? details.signature1 : ''),
      achivementDate1: new FormControl((details && details.achivementDate1) ? details.achivementDate1 : ''),
      signature2: new FormControl((details && details.signature2) ? details.signature2 : ''),
      achivementDate2: new FormControl((details && details.achivementDate2) ? details.achivementDate2 : ''),
      signature3: new FormControl((details && details.signature3) ? details.signature3 : ''),
    })
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'assesmentForm')
      this.assesmentForm.get(formControl).setValue(value);
  }

  get actionsDetails() { return <FormArray>this.assesmentForm.get('assesorList'); }
  assesorList(details?) {

    if (details && details.length) {
      let unitArray = []
      _.forEach(details, async (item, index) => {
        await unitArray.push(new FormGroup({
          assesorName: new FormControl((item && item.assesorName) ? item.assesorName : ''),
          assesorNumber: new FormControl((item && item.assesorNumber) ? item.assesorNumber : '')
        }))
      })
      return unitArray;
    } else {
      return [this.formBuilder.group({
        assesorName: new FormControl(''),
        assesorNumber: new FormControl('')
      })]
    }
  }


  deleteAssesor(data, i) {
    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.assesmentForm.controls.assesorList
    control.removeAt(i)
  }


  addAssesor() {
    const control = <FormArray>this.assesmentForm.controls.assesorList

    control.push(this.formBuilder.group({
      assesorName: new FormControl(''),
      assesorNumber: new FormControl('')
    }))
  }


  get verifierDetails() { return <FormArray>this.assesmentForm.get('verifierList'); }
  verifierList(details?) {

    if (details && details.length) {
      let unitArray = []
      _.forEach(details, async (item, index) => {
        await unitArray.push(new FormGroup({
          verifierName: new FormControl((item && item.verifierName) ? item.verifierName : ''),
          verifierNumber: new FormControl((item && item.verifierNumber) ? item.verifierNumber : '')
        }))
      })
      return unitArray;
    } else {
      return [this.formBuilder.group({
        verifierName: new FormControl(''),
        verifierNumber: new FormControl('')
      })]
    }
  }

  deleteVerifier(data, i) {
    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.assesmentForm.controls.verifierList
    control.removeAt(i)
  }


  addVerifier() {
    const control = <FormArray>this.assesmentForm.controls.verifierList

    control.push(this.formBuilder.group({
      verifierName: new FormControl(''),
      verifierNumber: new FormControl('')
    }))
  }


  get sampleDetails() { return <FormArray>this.assesmentForm.get('sampleList'); }
  sampleList(details?) {

    if (details && details.length) {
      let unitArray = []
      _.forEach(details, async (item, index) => {
        await unitArray.push(new FormGroup({
          name: new FormControl((item && item.name) ? item.name : ''),
          sign: new FormControl((item && item.sign) ? item.sign : '')
        }))
      })
      return unitArray;
    } else {
      return [this.formBuilder.group({
        name: new FormControl(''),
        sign: new FormControl('')
      })]
    }
  }


  deleteSample(data, i) {
    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.assesmentForm.controls.sampleList
    control.removeAt(i)
  }


  addSample() {
    const control = <FormArray>this.assesmentForm.controls.sampleList

    control.push(this.formBuilder.group({
      name: new FormControl(''),
      sign: new FormControl('')
    }))
  }



  // UTILITY


  addSignature(item, i) {

    this.openDialog(SignaturePadComponent).subscribe((data) => {
      if (data == undefined) return

      let sign = data
      const control = <FormArray>this.assesmentForm.controls.sampleList
      console.log("what is control ", control.controls[i]);
      control.at(i).patchValue({
        sign: sign
      });
      // console.log("final form value", this.specimanForm.value);
    })
  }

  addOtherSignature(control) {
    this.openDialog(SignaturePadComponent).subscribe((data) => {
      if (data == undefined) return

      let sign = data
      if (control == 'signature') {
        this.signature = true
        this.assesmentForm.patchValue({
          signature: sign
        })
      }
      if (control == 'signature1') {
        this.signature1 = true
        this.assesmentForm.patchValue({
          signature1: sign
        })
      }
      if (control == 'signature2') {
        this.signature2 = true
        this.assesmentForm.patchValue({
          signature2: sign
        })
      }
      if (control == 'signature3') {
        this.signature3 = true
        this.assesmentForm.patchValue({
          signature3: sign
        })
      }


    })
  }



  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }




  // API CALL



  submitForm() {
    console.log("this is the final form value to be stored", this.assesmentForm.value);
    this.loading = true
    let data = {
      learnerId: this.learnerData._id,
      jobId: this.currentJob,
      version: true,
      details: {
        assesmentForm: this.assesmentForm.value
      }
    }

    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      // this.loading = false
      console.log("policy not accepted", err)
      this.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
    })

  }



}
